// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3WyQg","title":"AfterFrontImage_title__3A-7I"};